import { render } from "./NavigationHeader.vue?vue&type=template&id=54275466&scoped=true&ts=true"
import script from "./NavigationHeader.vue?vue&type=script&lang=ts"
export * from "./NavigationHeader.vue?vue&type=script&lang=ts"

import "./NavigationHeader.vue?vue&type=style&index=0&id=54275466&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54275466"]])

export default __exports__